<template>
    <button :class="buttonClasses">
        <slot></slot>
    </button>
</template>

<script setup lang="ts">
interface ButtonProps {
    theme: "LIGHT" | "DARK"
    size: "sm" | "md" | "lg"
    outlined?: boolean
}

const buttonProps = withDefaults(defineProps<ButtonProps>(), {
    outlined: false
})

const buttonSizeClasses = computed(() => {
  switch (buttonProps.size) {
    case 'lg':
      return 'font-bold text-[16px] py-[10px] px-[20px]'
    case "md":
      return 'font-bold text-[16px] py-[10px] px-[20px]'
    default:
      return 'font-bold text-[14px] py-[6px] px-[16px]'
  }
})
const buttonColorClasses = computed(() => {
  switch (buttonProps.theme) {
    case "DARK":
      switch (buttonProps.outlined) {
        case true:
          return 'bg-transparent border text-white border-white hover:bg-transparent hover:text-[#BDBDBD] hover:border-[#BDBDBD] disabled:border-[#464545] disabled:text-[#464545]'
        default:
          return 'text-[#555] bg-white hover:text-[#757575]'
      }
    default:
      switch (buttonProps.outlined) {
        case true:
          return 'bg-transparent border text-[#424242] border-gray-800 hover:bg-transparent hover:text-[#757575] hover:border-[#757575] disabled:border-[#BDBDBD] disabled:text-[#BDBDBD] disabled:bg-transparent'
        default:
          return 'bg-[#424242] text-white hover:bg-[#757575] disabled:bg-[#BDBDBD]'
      }
  }
})
const buttonClasses = computed(() => {
  return buttonSizeClasses.value + ' ' + buttonColorClasses.value
})
</script>